exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable[data-v-5194d0e8]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;overflow:hidden;.sorting-indicator{position:relative;padding-left:.5rem;.fad{color:#59698f;font-size:.6rem}}.column-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.active{background-color:#d6def2!important;.sorting-indicator .fad{color:#111}}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5194d0e8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/report/daily-report/widgets/Report.vue
// module id = 73FP
// module chunks = 0